import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { ServicePageLayout } from "@/components/ServicePageLayout";
import { SERVICE_PAGES } from "@/lib/service-content";
import { buildService, buildFaqPage, buildBreadcrumbs, buildLocalBusiness } from "@/components/SchemaJsonLd";

const data = SERVICE_PAGES["polyaspartic-floor-coatings"];

export const Route = createFileRoute("/services/polyaspartic-floor-coatings")({
  head: () => ({
    meta: [
      { title: "Polyaspartic Floor Coatings in the Calgary region | MLC Epoxy Floors" },
      { name: "description", content: "Premium polyaspartic garage floor coatings — UV stable, 1-day install, outperforms traditional epoxy. Serving Calgary and the entire Calgary Region." },
      { property: "og:title", content: "Polyaspartic Floor Coatings | MLC Epoxy Floors" },
      { property: "og:description", content: "Next-generation UV-stable polyaspartic floor coatings installed in a single day." },
      { property: "og:url", content: "/services/polyaspartic-floor-coatings" },
    ],
    links: [{ rel: "canonical", href: "/services/polyaspartic-floor-coatings" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildLocalBusiness()) },
      { type: "application/ld+json", children: JSON.stringify(buildService(data.name, data.slug, data.intro)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }, { name: data.name, href: `/services/${data.slug}` }
      ])) },
    ],
  }),
  component: () => <ServicePageLayout {...data} />,
});
